// Reels → inline teaser continuity: the position of the reel being watched when the
// member leaves the Reels page. The feed card / discover tile of that reel resumes its
// muted teaser from the very same second, plays on to the end, then loops from 0.
// In-memory + short-lived: it is a transition, not a preference (the persisted
// "resume where I left" lives in reelPrefs and is governed by the admin switch).
const TTL_MS = 10 * 60 * 1000;
const map = new Map();

export const setReelHandoff = (id, t, duration) => {
  if (!id || typeof t !== "number" || !isFinite(t) || t < 1) return;
  if (duration && t >= duration - 1) { map.delete(id); return; }
  map.set(id, { t, at: Date.now() });
};

// Read WITHOUT consuming: the teaser clears it once it actually plays from there
// (React StrictMode double-runs effects; a consumed-on-read entry would be lost).
export const peekReelHandoff = (id) => {
  const e = id ? map.get(id) : null;
  if (!e) return 0;
  if (Date.now() - e.at > TTL_MS) { map.delete(id); return 0; }
  return e.t;
};

export const clearReelHandoff = (id) => { map.delete(id); };
